<div class="tablet-show fadeIn"><h1>Меню</h1><ProfileMenu></ProfileMenu><Menu></Menu></div>